import { Flex } from "antd";
import { FC } from "react";
import { formatUAHNumber, formatUAHStandard } from "tm-shared/utils";

import { DashboardProgress } from "@/features/Dashboard/components/DashboardProgress";
import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

import { StyledProductTagSpecial } from "./Styled";
import { KPIMetadata } from "./utils";

interface KPICollapseHeaderProps {
    metadata: KPIMetadata;
}

export const KPICollapseHeader: FC<KPICollapseHeaderProps> = ({ metadata }) => {
    const {
        groupType,
        isDropout,
        name,
        bonus,
        percent,
        maxPercent,
        isTargetReached,
        factCount,
        planCount,
        Icon,
    } = metadata;

    return (
        <Flex vertical gap={2}>
            <Flex justify="space-between" align="flex-start" gap={8}>
                <Flex gap={8} align="center" wrap="wrap">
                    {groupType === "special" && (
                        <StyledProductTagSpecial $isDropout={isDropout}>
                            {isDropout ? "Вибуття" : "Спецзадача"}
                        </StyledProductTagSpecial>
                    )}

                    <SecondaryText>{name}</SecondaryText>
                </Flex>

                <PrimaryText fontWeight="500" textNoWrap>
                    {formatUAHStandard(bonus.current)}
                </PrimaryText>
            </Flex>

            {!isDropout && (
                <Flex gap={16} align="center">
                    <DashboardProgress
                        value={Math.round(percent)}
                        limit={maxPercent ?? 0}
                    />

                    <Flex gap={4} align="center">
                        <Flex vertical align="flex-end">
                            <PrimaryText
                                fontWeight="500"
                                lineHeight="120%"
                                textNoWrap
                                textColor={
                                    isTargetReached ? "success" : "error"
                                }
                            >
                                {formatUAHNumber(factCount)}
                            </PrimaryText>

                            <PrimaryText
                                fontWeight="500"
                                fontSize={10}
                                lineHeight="100%"
                                style={{ whiteSpace: "nowrap" }}
                            >
                                {formatUAHNumber(planCount)}
                            </PrimaryText>
                        </Flex>

                        {Icon && (
                            <PrimaryText
                                fontSize={24}
                                textColor={
                                    isTargetReached ? "success" : "error"
                                }
                            >
                                <Icon />
                            </PrimaryText>
                        )}
                    </Flex>
                </Flex>
            )}
        </Flex>
    );
};
